var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerSeats5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4.5a7.5 7.5 0 010 15H9a7.5 7.5 0 010-15h6zM9.568 6.586l-.578 5.361 1.406.345c.19-.181.395-.332.615-.455.225-.122.547-.183.967-.183.313 0 .588.054.828.161.239.103.437.25.593.44.161.19.28.415.359.674.083.258.124.544.124.857 0 .327-.036.625-.11.893a2.021 2.021 0 01-.322.703c-.141.196-.32.347-.534.454a1.77 1.77 0 01-.77.154c-.327 0-.615-.063-.864-.19a1.512 1.512 0 01-.6-.55 2.259 2.259 0 01-.286-.886H8.667c.03.493.142.93.337 1.311.196.376.455.694.777.952.322.254.686.447 1.091.58.41.126.838.19 1.282.19.595 0 1.11-.09 1.545-.271.44-.186.803-.442 1.091-.77.289-.327.504-.705.645-1.135.146-.43.22-.89.22-1.384 0-.552-.073-1.047-.22-1.487a3.105 3.105 0 00-.637-1.128 2.686 2.686 0 00-1.018-.71 3.454 3.454 0 00-1.348-.25c-.376 0-.71.05-1.003.147a3.451 3.451 0 00-.689.286l.293-2.615h4.285V6.586h-5.75z",
    fill: "currentColor"
  })));
}
SvgPokerSeats5.displayName = 'PokerSeats5';
export default SvgPokerSeats5;